<template>
    <b-overlay :show="busy" rounded="sm">
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">
                        <!-- {{ parent }} -->

                        <b-tabs class="gridtabs">

                            <b-tab active>
                                <template #title>
                                    <i :class="options.icon_header" class="text-purple mr-1"></i>
                                    {{ item.referenceno ? item.referenceno : item.locator }}
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                    }}&gt;</span>
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">

                                            <!-- <b-form-group label-cols="12" label="Type" label-size="sm">
                                                <treeselect placeholder="Type" v-model="item.type" :clearable="false"
                                                    :multiple="false" :options="options_type" :matchKeys="['id']"
                                                    :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group> -->

                                            <b-form-group label-cols="12" label="Type" label-size="sm">
                                                <treeselect placeholder="Select supplier type..."
                                                    searchPromptText="Supplier Type..." v-model="item.type"
                                                    :clearable="false" :multiple="false" :options="options_suppliertype"
                                                    :disabled="readonly" :matchKeys="['id']">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>


                                        </b-col>
                                        <!-- <b-col>
                                                    <b-form-group label-cols="12" label="Source" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.source"
                                                                :debounce="options.debounce" placeholder="Source"
                                                                :disabled="true"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>

                                                </b-col> -->

                                        <b-col cols="12" sm="6" md="4" xl="3">

                                            <b-form-group label-cols="12" label="Status" label-size="sm">
                                                <treeselect placeholder="Status" v-model="item.status"
                                                    :clearable="false" :multiple="false" :options="options_status"
                                                    :matchKeys="['id']" :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.label }}
                                                    </div>
                                                </treeselect>

                                            </b-form-group>

                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3"> <b-form-group label-cols="12" label="Qty"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.qty" :debounce="options.debounce"
                                                        placeholder="Qty" :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.qty = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group></b-col>



                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group :disabled="readonly" label-cols="12" label="Agent"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.agent" placeholder="Agent"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.agent = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Invoice No" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.invoiceno"
                                                                :debounce="options.debounce" placeholder="Invoice No"
                                                                :disabled="!user.permissions.includes('conferma.admin')"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="!user.permissions.includes('conferma.admin')"
                                                                    @click="item.invoiceno = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <!-- <b-col>
                                                    <b-form-group label-cols="12" label="Payment Method"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <treeselect placeholder="Payment Method"
                                                                v-model="item.payby" :clearable="false"
                                                                :multiple="false" :options="payby_options"
                                                                :matchKeys="['id']">
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col> -->
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Date Issued" label-size="sm"
                                                        :disabled="true">
                                                        <b-input-group>
                                                            <b-form-input :value="item.issued_at
                                                                ? this.$helpers.datetimefield(item.issued_at)
                                                                : null
                                                                " :disabled="readonly"></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Last4" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.last4"
                                                                :debounce="options.debounce" placeholder="Last4"
                                                                :disabled="true" trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="true" @click="item.last4 = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="TransactionId" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.referenceno"
                                                                :debounce="options.debounce" placeholder="TransactionId"
                                                                :disabled="true" trim></b-form-input>
                                                            <!-- <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="true" @click="item.referenceno = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append> -->
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="DeploymentId" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.token"
                                                                :debounce="options.debounce" placeholder="DeploymentId"
                                                                :disabled="true" trim></b-form-input>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">

                                            <b-form-group label-cols="12" label="Quoted" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.quoted" :debounce="options.debounce"
                                                        placeholder="Quoted" :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.quoted = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>

                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Grouping" label-size="sm">
                                                <treeselect placeholder="Grouping" v-model="item.grouping"
                                                    :clearable="false" :multiple="false" :options="options_grouping"
                                                    :matchKeys="['id']" :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6">

                                            <b-form-group label-cols="12" label="Supplier" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.description"
                                                        :debounce="options.debounce" placeholder="Supplier"
                                                        :disabled="true" trim></b-form-input>
                                                </b-input-group>
                                            </b-form-group>

                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group label-cols="12" label="Local Currency"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.costlocalcurrency"
                                                                :debounce="options.debounce"
                                                                placeholder="Local Currency" :disabled="true"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="true"
                                                                    @click="item.costlocalcurrency = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col>
                                                    <b-form-group id="costlocal" label="Local Amount"
                                                        label-for="costlocal" label-cols="12">
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.costlocal"
                                                                placeholder="Local Amount" size="sm" :disabled="true"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="true"
                                                                    variant="outline-secondary"
                                                                    @click="item.costlocal = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>

                                                </b-col>

                                            </b-row>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col><b-form-group label-cols="12" label="Currency" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.costcurrency"
                                                                :debounce="options.debounce" placeholder="Currency"
                                                                :disabled="true" trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="true" @click="item.costcurrency = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>

                                                </b-col>
                                                <b-col>
                                                    <b-form-group id="cost" label="Cost" label-for="cost"
                                                        label-cols="12">
                                                        <!-- <b-input-group class="treeselect_all" style="left:30px; top:-12px">
                                                    <i class="fa fa-info-circle text-danger"></i>
                                                </b-input-group>
                                                <b-tooltip target="cost" triggers="hover" placement="bottom">Be sure
                                                    to
                                                    check your Bought Ledger costs!</b-tooltip>-->
                                                        <!-- :state="false"  -->
                                                        <b-input-group>
                                                            <b-form-input type="text" v-model="item.cost"
                                                                placeholder="Cost" size="sm" :disabled="true"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" :disabled="true"
                                                                    variant="outline-secondary" @click="item.cost = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                        </b-col>


                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="!user.permissions.includes('conferma.save')">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Markup" label-for="markup" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.markup" placeholder="Markup"
                                                        size="sm"
                                                        :disabled="!user.permissions.includes('conferma.save')"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('conferma.save')"
                                                            variant="outline-secondary" @click="item.markup = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Sale" label-for="sale" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.sale" placeholder="Sale"
                                                        size="sm"
                                                        :disabled="!user.permissions.includes('conferma.save')"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm"
                                                            :disabled="!user.permissions.includes('conferma.save')"
                                                            variant="outline-secondary" @click="item.sale = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="!user.permissions.includes('conferma.save')">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Your Ref/PO" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.yourref" :debounce="options.debounce"
                                                        placeholder="Your Ref/PO"
                                                        :disabled="!user.permissions.includes('conferma.save')"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="!user.permissions.includes('conferma.save')"
                                                            @click="item.yourref = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event..." v-model="item.eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    searchPromptText="Type at least 4 chars..." :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested
                                                    :disabled="!user.permissions.includes('conferma.save')">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">

                                            <b-form-group label-cols="12" label="GDS Locator" label-size="sm"
                                                id="locator">
                                                <b-input-group>
                                                    <b-input-group class="treeselect_all" style="left:62px; top:-12px">
                                                        <i class="fa fa-info-circle"></i>
                                                    </b-input-group>
                                                    <b-tooltip target="locator" triggers="hover" placement="bottom">GDS
                                                        Locator</b-tooltip>
                                                    <b-form-input v-model="item.locator" :debounce="options.debounce"
                                                        placeholder="GDS Locator" :disabled="true" trim></b-form-input>
                                                </b-input-group>
                                            </b-form-group>

                                        </b-col>


                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">

                                            <b-form-group label-cols="12" label="Booker" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.booker" :debounce="options.debounce"
                                                        placeholder="Booker" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly"
                                                            @click="item.booker = reversenamecap(item.booker)"
                                                            title="Reverse Name Capitalise">
                                                            <i class="fa fa-exchange text-primary"></i>
                                                        </b-button>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.booker = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col> -->
                                    </b-row>
                                    <b-row align-v="end" class="nopadding my-1 mt-3 background-transparent" no-gutters>
                                        <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                            <b-row>
                                                <b-col class="text-left">First Segment</b-col>
                                                <!-- <b-col class="text-right">1 of Total</b-col> -->
                                            </b-row>

                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Start City" label-size="sm">
                                                <treeselect placeholder="Select city..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.startcity"
                                                    :clearable="true" :async="true" :disabled="readonly"
                                                    :load-options="treeselect_loadAirport" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" :title="item.startcity +
                                                        ' ( ' +
                                                        item.startcityname +
                                                        ' )'
                                                        " search-nested>
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                        {{ node.raw.id && item.startcityname ? '( ' + item.startcityname
                                                            +
                                                            ')' : "" }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>

                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Start DateTime"
                                                label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                        v-model="datestart" :disabled="readonly" :opens="'right'"
                                                        :single-date-picker="'single'" :locale-data="{
                                                            direction: 'ltr',
                                                            format: 'dd/mm/yy HH:MM',
                                                            daysOfWeek: [
                                                                'Sun',
                                                                'Mon',
                                                                'Tue',
                                                                'Wed',
                                                                'Thu',
                                                                'Fri',
                                                                'Sat',
                                                            ],
                                                            monthNames: [
                                                                'January',
                                                                'February',
                                                                'March',
                                                                'April',
                                                                'May',
                                                                'June',
                                                                'July',
                                                                'August',
                                                                'September',
                                                                'October',
                                                                'November',
                                                                'December',
                                                            ],
                                                            firstDay: 1,
                                                        }" :ranges="false" :showDropdowns="true"
                                                        :linkedCalendars="true" :timePicker="true"
                                                        :timePicker24Hour="true" :time-picker-increment="1">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.start_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="End DateTime"
                                                label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                        v-model="dateend" :disabled="readonly" :opens="'right'"
                                                        :single-date-picker="'single'" :locale-data="{
                                                            direction: 'ltr',
                                                            format: 'dd/mm/yy HH:MM',
                                                            daysOfWeek: [
                                                                'Sun',
                                                                'Mon',
                                                                'Tue',
                                                                'Wed',
                                                                'Thu',
                                                                'Fri',
                                                                'Sat',
                                                            ],
                                                            monthNames: [
                                                                'January',
                                                                'February',
                                                                'March',
                                                                'April',
                                                                'May',
                                                                'June',
                                                                'July',
                                                                'August',
                                                                'September',
                                                                'October',
                                                                'November',
                                                                'December',
                                                            ],
                                                            firstDay: 1,
                                                        }" :ranges="false" :showDropdowns="true"
                                                        :linkedCalendars="true" :timePicker="true"
                                                        :timePicker24Hour="true" :time-picker-increment="1">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.end_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="End City"
                                                label-size="sm">
                                                <treeselect placeholder="Select city..."
                                                    searchPromptText="Type at least 3 chars..." v-model="item.endcity"
                                                    :disabled="readonly" :clearable="readonly" :async="true"
                                                    :load-options="treeselect_loadAirport" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" :title="item.endcity +
                                                        ' ( ' +
                                                        item.endcityname +
                                                        ' )'
                                                        " search-nested>
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                        {{ node.raw.id && item.endcityname ? '( ' + item.endcityname + '
                                                        ) '
                                                        : "" }}
                                                    </div>
                                                </treeselect>

                                            </b-form-group>

                                        </b-col>

                                        <b-col cols="12" sm="6" md="6" xl="6">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Start Location"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.startlocation"
                                                        :debounce="options.debounce" placeholder="Start Location"
                                                        :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.startlocation = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="6" xl="6">
                                            <b-form-group :disabled="readonly" label-cols="12" label="End Location"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.endlocation"
                                                        :debounce="options.debounce" placeholder="End Location"
                                                        :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.endlocation = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Flight No"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.flightno" :debounce="options.debounce"
                                                        placeholder="Flight No" :disabled="readonly"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.flightno = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group v-if="item.type == 'A'" :disabled="readonly" label-cols="12"
                                                label="Marketing Carrier" label-size="sm">
                                                <b-input-group>
                                                    <!-- <b-form-input v-model="item.marketingcarrier"
                                                        :debounce="options.debounce" placeholder="Marketing Carrier"
                                                        :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.marketingcarrier = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append> -->

                                                    <treeselect :disabled="readonly" placeholder="Select marketing carrier..."
                                                        v-model="item.marketingcarrier" :clearable="true"
                                                        :options="options_airline">
                                                        <div slot="value-label" slot-scope="{ node }">
                                                            <!-- {{ node.raw.id }} -->
                                                            {{ node.raw.label }}
                                                        </div>
                                                    </treeselect>
                                                </b-input-group>
                                            </b-form-group>
                                            <b-form-group v-else :disabled="readonly" label-cols="12"
                                                label="Supplier Code" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.marketingcarrier"
                                                        :debounce="options.debounce" placeholder="Supplier Code"
                                                        :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.marketingcarrier = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" id="cabinco2" label-cols="12"
                                                label="Cabin CO2" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:65px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <b-tooltip target="cabinco2" triggers="hover"
                                                    placement="bottom">Required
                                                    field for
                                                    Carbon</b-tooltip>
                                                <treeselect placeholder="Cabin CO2" v-model="item.cabin"
                                                    :clearable="false" :multiple="false" :options="options_cabin"
                                                    :matchKeys="['id']" :disabled="readonly">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>

                                        </b-col>

                                        <b-col id="equipmentco2" cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" v-if="item.type == 'C'" label-cols="12"
                                                label="Equipment (SIPP) CO2" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:120px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <treeselect :disabled="readonly" placeholder="Equipment (SIPP)"
                                                    v-model="item.equipment" :clearable="false" :multiple="false"
                                                    :options="options_cartypecode" :matchKeys="['id']">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                            <b-form-group :disabled="readonly" v-if="item.type == 'A'" label-cols="12"
                                                label="Equipment (aircraft) CO2" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:140px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <treeselect :disabled="readonly" placeholder="Equipment (aircraft)"
                                                    v-model="item.equipment" :clearable="false"
                                                    :options="options_aircraft">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        <!-- {{ node.raw.id }} -->
                                                        {{ node.raw.label }}
                                                    </div>
                                                </treeselect>

                                                <!-- <treeselect placeholder="Equipment (SIPP)" v-model="item.equipment"
                                                    :clearable="false" :multiple="false" :options="options_cartypecode"
                                                    :matchKeys="['id']">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect> -->
                                            </b-form-group>
                                            <b-form-group :disabled="readonly"
                                                v-if="item.type !== 'A' && item.type !== 'C'" label-cols="12"
                                                label="Equipment CO2" label-size="sm">
                                                <b-input-group class="treeselect_all" style="left:90px; top:-15px">
                                                    <i class="fa fa-leaf text-primary"></i>
                                                </b-input-group>
                                                <b-input-group>
                                                    <b-form-input :disabled="readonly" v-model="item.equipment"
                                                        :debounce="options.debounce" placeholder="Equipment"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.equipment = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                            <b-tooltip target="equipmentco2" triggers="hover"
                                                placement="bottom">Required
                                                field for
                                                Carbon</b-tooltip>
                                        </b-col>

                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="ConfirmNo" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.confirmno" :debounce="options.debounce"
                                                        placeholder="ConfirmNo" :disabled="readonly"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.confirmno = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col> -->



                                    </b-row>
                                    <b-row align-v="end" class="nopadding my-1 mt-3 background-transparent" no-gutters>
                                        <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                            <b-row>
                                                <b-col class="text-left">First Traveller</b-col>
                                                <!-- <b-col class="text-right">1 of Total</b-col> -->
                                            </b-row>

                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Passenger"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.passenger" :debounce="options.debounce"
                                                        placeholder="Passenger" :disabled="readonly"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly"
                                                            @click="item.passenger = reversenamecap(item.passenger, true)"
                                                            title="Reverse Name Capitalise">
                                                            <i class="fa fa-exchange text-primary"></i>
                                                        </b-button>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.passenger = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Surname"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.surname" :debounce="options.debounce"
                                                        placeholder="Surname" :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.surname = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group :disabled="readonly" label-cols="12" label="First Name"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.firstname" :debounce="options.debounce"
                                                        placeholder="First Name" :disabled="readonly"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.firstname = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>


                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-row>
                                                <b-col>
                                                    <b-form-group :disabled="readonly" label-cols="12" label="Title"
                                                        label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input v-model="item.title"
                                                                :debounce="options.debounce" placeholder="Title"
                                                                :disabled="readonly" list="list-title"
                                                                trim></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.title = ''">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col>
                                                <!-- <b-col>
                                                    <b-form-group label-cols="12" label="Travellers" label-size="sm">
                                                        <b-input-group>
                                                            <b-form-input type="number" :min="0" :max="50"
                                                                v-model="item.pax" :debounce="options.debounce"
                                                                placeholder="Pax" :disabled="readonly"></b-form-input>
                                                            <b-input-group-append>
                                                                <b-button size="sm" variant="outline-secondary"
                                                                    :disabled="readonly" @click="item.pax = '0'">
                                                                    <i class="fa fa-remove"></i>
                                                                </b-button>
                                                            </b-input-group-append>
                                                        </b-input-group>
                                                    </b-form-group>
                                                </b-col> -->
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row align-v="end" class="nopadding my-1 mt-3 background-transparent" no-gutters>
                                        <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                            <b-row>
                                                <b-col class="text-left">Invoicing</b-col>
                                                <!-- <b-col class="text-right">1 of Total</b-col> -->
                                            </b-row>

                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Travellers"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.travellers" :debounce="options.debounce"
                                                        placeholder="Travellers" :disabled="readonly"
                                                        trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.travellers = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6">
                                            <b-form-group :disabled="readonly" label-cols="12" label="Routing"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.routing" :debounce="options.debounce"
                                                        placeholder="Route" :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.routing = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <b-form-group :disabled="readonly" label-cols="12" label="Remark"
                                                label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-model="item.remark" :debounce="options.debounce"
                                                        placeholder="Remark" :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            :disabled="readonly" @click="item.remark = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                                        <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                            MI Fields
                                        </b-col>
                                    </b-row>

                                    <!-- {{ mifields }} -->
                                    <b-row v-if="mifields.length > 0">
                                        <b-col cols="12" sm="6" md="4" xl="3" v-for="(mifield, index) in mifields"
                                            :key="index">
                                            <b-form-group :label="$helpers.requiredlabel(requirement, mifield.label)"
                                                :class="$helpers
                                                    .requiredlabel(requirement, mifield.label)
                                                    .slice(0, 1) == '*'
                                                    ? 'text-danger'
                                                    : ''
                                                    " label-cols="12" label-size="sm">
                                                <b-input-group>
                                                    <b-form-input v-if="mifield.type == 'input'" type="text"
                                                        :disabled="mifield.active == '0'" size="sm" trim
                                                        v-model="mifield.value"
                                                        :placeholder="mifield.label"></b-form-input>
                                                    <b-input-group-append v-if="mifield.type == 'input'"
                                                        @click="mifield.value = ''">
                                                        <b-button size="sm" variant="outline-secondary">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                                <treeselect v-if="mifield.type == 'listofvalues'" :show-count="true"
                                                    :flatten-search-results="true" :clearable="false"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :options="mifield.options" v-model="mifield.value">
                                                </treeselect>

                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <b-row v-if="mifields.length == 0">
                                        <b-col>
                                            There are no fields to display
                                        </b-col>
                                    </b-row>


                                    <b-row v-if="permissionvalid('systems.development')" class="mt-3">
                                        <b-col cols="12" sm="12">
                                            <b-form-group label="Tags" label-for="tags" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.tags" placeholder="Tags"
                                                        size="sm" :disabled="readonly" trim></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="readonly"
                                                            variant="outline-secondary" @click="item.tags = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>


                            <b-tab @click="load_bankingline()">
                                <template #title alt="Statement">
                                    <i class="fa fa-university text-dark mr-1"></i> Statement
                                </template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col>
                                            <b-form-group label="Statement details" label-for="notes" label-cols="12">
                                                <b-form-textarea id="data" v-model="data" placeholder="Data" rows="30"
                                                    max-rows="30" class="smalltextarea courier"
                                                    :disabled="true"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>


                                </p>
                            </b-tab>

                            <b-tab v-if="user.permissions.includes('conferma.admin')">
                                <template #title>
                                    <i class="fa fa-comments-o text-primary mr-1"></i>
                                    Notes</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Notes" label-for="notes" label-cols="12">
                                                <b-form-textarea id="data" v-model="item.notes" placeholder="Notes"
                                                    rows="12" class="smalltextarea"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                    <b-row class="mt-1">
                                        <b-col>
                                            <b-button squared size="sm" variant="outline-primary" class="mr-1"
                                                @click="timestamp">
                                                <i class="fa fa-comment-o"></i>
                                                Add Notes
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab v-if="user.permissions.includes('conferma.admin')">
                                <template #title>
                                    <i class="fa fa-balance-scale text-primary mr-1"></i>
                                    Accounts Only</template>
                                <p class="py-3 px-0">
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label="Accounts Only" label-for="accountsonly"
                                                label-cols="12">
                                                <b-form-textarea id="data" v-model="item.accountsonly"
                                                    placeholder="Accounts Only" rows="12"
                                                    class="smalltextarea"></b-form-textarea>
                                            </b-form-group> </b-col></b-row>
                                    <b-row class="mt-1">
                                        <b-col>
                                            <b-button squared size="sm" variant="outline-primary" class="mr-1"
                                                @click="timestamp('accountsonly')">
                                                <i class="fa fa-clock-o"></i>
                                                Add a timestamp
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab v-if="idselected">
                                <template #title>
                                    <i class="fa fa-history text-primary mr-1"></i> Audit
                                </template>
                                <p class="py-3 px-0">

                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.created_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.created_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.created_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                                <b-input-group>
                                                    <b-input-group-prepend>
                                                        <b-form-datepicker size="sm" v-model="item.updated_at"
                                                            button-only label-help="" locale="en-GB"
                                                            :disabled="true"></b-form-datepicker>
                                                    </b-input-group-prepend>
                                                    <b-form-input size="sm" id="date" v-model="item.updated_at"
                                                        type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                                        :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_at = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                        size="sm" :disabled="true"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="item.updated_by = ''" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="ID" label-for="id" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                        :disabled="true"></b-form-input>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </p>
                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="user.permissions.includes('conferma.save')" :disabled="postit_disabled">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card-footer>
                    <datalist id="list-title">
                        <option v-for="item in options_title" :key="item">{{ item }}</option>
                    </datalist>

                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

import ExcelJS from "exceljs";
import * as fs from "file-saver";

import formatXML from "xml-formatter";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import SshPre from "simple-syntax-highlighter";
import "simple-syntax-highlighter/dist/sshpre.css";

function tabToObjArr(text) {

    let raw = text.trim().split('"').join("")
    let allcols = raw.split("\t")

    let headers = raw.split("\n")[0].split("\t")
    let cb = headers.length - 1
    let cols = []
    for (let i = 0; i < allcols.length; i++) {
        if (i == cb) {
            let parts = allcols[i].trim().split("\n")
            for (let k = 0; k < parts.length; k++) {
                cols.push(parts[k].trim())
            }
            cb += headers.length - 1
        } else {
            cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
        }
    }
    console.log('cols=', cols)

    cb = headers.length - 1
    let rows = []
    let item = {}
    let k = 0
    for (let i = 0; i < cols.length; i++) {
        if (i == cb) {
            item[headers[k]] = cols[i]
            rows.push(item)
            cb += headers.length
            item = {}
            k = 0
        } else {
            item[headers[k]] = cols[i]
            k += 1
        }
    }
    return rows;
}

function csvToArray(text) {
    let p = '', row = [''], ret = [row], i = 0, r = 0, s = !0, l;
    for (l of text) {
        if ('"' === l) {
            if (s && l === p) row[i] += l;
            s = !s;
        } else if (',' === l && s) l = row[++i] = '';
        else if ('\n' === l && s) {
            if ('\r' === p) row[i] = row[i].slice(0, -1);
            row = ret[++r] = [l = '']; i = 0;
        } else row[i] += l;
        p = l;
    }
    return ret;
};

export default {
    name: "InventoryLinesEdit",
    components: {
        VueJsonPretty, SshPre
    },
    props: {
        parent: { type: String, default: "inventoryline" },
    },
    mounted() {
        this.item.agent = this.user.initials;
        if (this.parent) {
            if (this.parent != "inventoryline") {
                this.item.type = this.parent
            }
        }
    },
    data() {
        return {
            busy: false,
            message: null,
            load_busy: false,
            locked_at: false,
            disabled: true,
            postit_disabled: false,
            multiple: true,
            showedit: true,
            unblock: false,
            data: null,
            notes: null,
            accountsonly: null,
            markup_lineprice: "0.00",
            markup_linesubtotal: "0.00",
            markup_costtotal: "0.00",
            datestart: { startDate: null, endDate: null },
            dateend: { startDate: null, endDate: null },
            xml: null,
            line: {},
            message: "",
            segmentgroup: null,
            itinerary_segments_sameasstart: false,
            itinerary_segments_input: false,
            itinerary_segments: [],
            payby_options: [],
            options_aircraft: [],
            options_airline: [],
            options_cabin: [
                { id: "ECONOMY", label: "ECONOMY" },
                { id: "PREMIUM", label: "PREMIUM" },
                { id: "BUSINESS", label: "BUSINESS" },
                { id: "FIRST", label: "FIRST" }
            ],
            options_transferequipments:
                [
                    { id: "MINIVAN", label: "MINIVAN" },
                    { id: "TAXI", label: "TAXI" },
                    { id: "MINIBUS", label: "MINIBUS" },
                    { id: "COACH", label: "COACH" }
                ],
            options_status: [
                { id: "ready", label: "Ready" },
                { id: "pending", label: "Pending" },
                { id: "offline", label: "Offline" },
            ],
            options_grouping: [
                { id: "deployed", label: "Deployed" },
                { id: "manual", label: "Manual" },
            ],
            options_segmentspriced: [
                { id: false, label: "No" },
                { id: true, label: "Yes" },
            ],
            options_proformalayout: [
                { id: "bytravellers", label: "ByTravellers" },
                { id: "bysegments", label: "BySegments" },
            ],
            type_options: [
                { id: 0, label: "File" },
                { id: 1, label: "File folder" },
            ],
            options_suppliertype: [],
            options_type: [
                { id: "AIR", label: "Air Ticketed" },
                { id: "CAR", label: "Cars" },
                { id: "HTL", label: "Hotels" },
                { id: "EMD", label: "EMD" },
                { id: "RAIL", label: "Rail/Eurostar" },
                { id: "XFR", label: "Transfers" },
                { id: "SEA", label: "Ferry" },

                // { id: "LOW", label: "Low Cost" },    
                // { id: "BAG", label: "Baggage" },
                // { id: "MTG", label: "Meetings" },
                // { id: "OTH", label: "Other" },
                // { id: "BMD", label: "Business" },
                // { id: "visa", label: "Visa" },
            ],
            options_paxtype: [
                { id: "INF", label: "INFANT" },
                { id: "CHD", label: "CHILD" },
                { id: "ADT", label: "ADULT" },
            ],
            options_state: [
                { id: 0, label: "Unsubmit" },
                { id: 1, label: "Submit" },
            ],
            options_title: ["MR", "MRS", "MISS", "MS", "DR"],
            options_cartypecode: [],
            documentxml: "",
            item: {
                type: "AIR",
                status: "HK",
                cabin: "ECONOMY",
                state: 0,
                segments_priced: false,
                qty: "0",
            },
            options: {
                title: "Edit Inventory Lines",
                icon_header: "fa fa-credit-card text-purple",
                icon: "fa fa-credit-card text-purple",
                debounce: 500,
                actions_as_elipses: false,
                modal: {},
                component: {},
                overlay_show: false,
                overlay: {},
            },
        };
    },
    computed: {
        readonly() {
            if (this.user.permissions.includes('conferma.save')) {
                return false //this.item.locked
            }
            return true;
        },
        // options_passenger() {
        //     let result = []
        //     for (let i = 0; i < this.items.length; i++) {
        //         let traveller = this.items[i]
        //         result.push({ id: traveller.passenger, label: traveller.passenger + " | " + traveller.firstname + " " + traveller.surname }
        //         )
        //     }
        //     return result
        // },

        // travellers_count() {
        //     let result = 0
        //     if (this.items.length > 0) {
        //         result = this.items.length
        //         if (parseInt(this.item.pax) > result) {
        //             result = parseInt(this.item.pax)
        //         }
        //     } else {
        //         result = this.item.pax
        //     }
        //     return result
        // },

        loadlabel() {
            let result = "Unknown"
            if (this.item) {
                if (this.item.type == 'AIR' || this.item.type == 'BAG') {
                    result = "GDS Locator(s) or TicketNo(s) ( 6 alpha or 10 / 13 numeric allowed )"
                }
                if (this.item.type == 'LOW') {
                    result = "GDS ConfirmNo"
                }
            }
            return result
        }
    },
    watch: {
        fileUpload: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    console.log("watch:fileUpload", newVal);
                }
            },

        },
        "item.name": {
            async handler(newVal, oldVal) {
                if (this.fileUpload) {
                    this.fileUpload.name = newVal;
                }
            },
        },
        "item.surname": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.item.passenger = newVal.toUpperCase()
                    if (this.item.firstname) {
                        this.item.passenger += "/" + this.item.firstname
                    }
                }
            },
        },
        "item.firstname": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.item.passenger = this.item.surname.toUpperCase() + "/" + newVal.toUpperCase()
                }
            },
        },
        "item.slac": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.slac = ""
                }
                await this.load_mifields();
            }
        },
        "item.eventcode": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.eventcode = ""
                }
            }
        },
        "item.startcity": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.startcity = ""
                }
            }
        },
        "item.endcity": {
            async handler(newVal, oldVal) {
                if (typeof newVal === "undefined") {
                    this.item.endcity = ""
                }
            }
        },
        "travellers.item.surname": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.travellers.item.passenger = newVal.toUpperCase() + "/"
                    if (this.travellers.item.firstname) {
                        this.travellers.item.passenger += this.travellers.item.firstname
                    }
                }
            }
        },
        "travellers.item.firstname": {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.travellers.item.passenger = this.travellers.item.surname.toUpperCase() + "/" + newVal.toUpperCase()
                }
            }
        },


        "xml": {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    let pnr = formatXML(newVal, {
                        indentation: "  ",
                        filter: (node) => node.type !== "Comment",
                        collapseContent: true,
                        lineSeparator: "\n",
                    });
                    this.xml = pnr
                }
            }
        },

    },
    methods: {
        async loadDDL() {
            console.log("loadDDL");
            this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query suppliertypes {
              suppliertypes {
                id
                label
                faicon
              }
            }
          `,
                });
                // this.options_suppliertype = response.data.suppliertypes;
                this.options_suppliertype = response.data.suppliertypes.filter(o => o.faicon != '');
            } catch (error) {
                console.log(error);
            }

            this.busy = false;
        },

        async load() {

            let variables = {
                id: this.idselected,
                // mssql: true,
            };
            console.log("variables", variables);

            this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
                    query inventorylines($id: String) {
                        inventorylines(id: $id) {
                            id
                            type
                            description
                            status
                            locator
                            eventcode
                            slac
                            yourref
                            issued_at
                            title
                            passenger
                            firstname
                            surname
                            startcity
                            startlocation
                            start_at
                            end_at
                            endcity
                            endlocation
                            referenceno
                            equipment
                            cabin
                            classcode
                            flightno
                            marketingcarrier
                            quoted
                            pax
                            qty
                            tax
                            sale
                            markup
                            cost
                            costlocal
                            costcurrency
                            costlocalcurrency
                            blinvoiceno
                            blac
                            payby
                            last4
                            invoiceno
                            reference
                            token
                            grouping
                            agent
                            routing
                            segments
                            tags
                            data
                            notes
                            travellers
                            accountsonly
                            invoicetype
                            flightno
                            remark
                            supplier
                            platform
                            branch
                            parent_id
                            created_at
                            created_by
                            updated_at
                            updated_by
                            rows
                            # travellers {
                            #     passenger
                            #     surname
                            #     firstname
                            #     title
                            #     paxtype
                            #     dob
                            #     mob
                            #     travellernumber
                            #     sabrenamenumber
                            # }                           
                    }
                  }
                `,
                    variables,
                });

                this.item = response.data.inventorylines[0];

                if (this.item.start_at) {
                    let v = this.$moment.unix(this.item.start_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    this.datestart = { startDate: v, endDate: v }
                }
                if (this.item.end_at) {
                    let v = this.$moment.unix(this.item.end_at / 1000).utc(false).format("YYYY-MM-DD HH:mm")
                    this.dateend = { startDate: v, endDate: v }
                }

                this.xml = this.item.pnr

                // this.travellers.items = this.item.travellers
                // this.travellers.edit = false
                // this.segments.items = this.item.segments
                // this.segments.edit = false
                // this.itineraries.items = this.item.itineraries
                // this.itineraries.edit = false

                if (this.item.associatedno) {
                    this.item.associatedno = this.item.associatedno.split(",")
                }

                if (this.item.data) {
                    this.fileUpload = JSON.parse(this.item.data);
                }
                this.sumcosttotal()

            } catch (error) {
                console.log(error);
            }


            try {
                const response = await this.$apollo.query({
                    query: gql`
            query bookingformspaytypes {
              bookingformspaytypes {
                id
                label: name
              }
            }
          `,
                });
                this.payby_options = response.data.bookingformspaytypes;
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_airlines {
              setup_airlines {
                id:code
                label
              }
            }
          `,
                });
                this.options_airline = response.data.setup_airlines;
            } catch (error) {
                console.log(error);
            }

            // LOAD OPTIONS BY TYPE
            switch (this.item.type) {

                case "C":
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                            query setup_carsipps {
                            setup_carsipps {
                                id
                                label
                            }
                            }
                        `,
                        });
                        this.options_cartypecode = response.data.setup_carsipps;
                    } catch (error) {
                        console.log(error);
                    }
                    break;

                case "A":
                    try {
                        const response = await this.$apollo.query({
                            query: gql`
                                query setup_aircrafts {
                                    setup_aircrafts {
                                    id: iatacode
                                    label
                                }
                                }
                            `,
                        });
                        this.options_aircraft = response.data.setup_aircrafts;
                    } catch (error) {
                        console.log(error);
                    }
                    break;

            }

            this.busy = false;
        },
        async saveit() {
            this.busy = true;

            let rows = [this.cleanit(this.item)];
            delete rows[0].issued_at

            let requirements = await this.mifields_requirement()
            if (requirements.length > 0) {
                this.message =
                    "<span class='text-danger'>" +
                    requirements.slice(0, -1) +
                    " required field(s). </span>";
                this.busy = false;
                return;
            } else {
                this.message = ""
            }

            rows[0].start_at = this.datestart.startDate
            rows[0].end_at = this.dateend.startDate

            if (this.item.pnr) {
                rows[0].pnr = Buffer.from(rows[0].pnr, "ascii").toString("base64");
            }
            if (this.item.associatedno) {
                rows[0].associatedno = this.item.associatedno.join(",")
            }
            // if (this.travellers.items) {
            //     rows[0].travellers = this.travellers.items
            // }
            // if (this.segments.items) {
            //     rows[0].segments = this.segments.items
            // }
            // if (this.itineraries.items) {
            //     rows[0].itineraries = this.itineraries.items
            // }

            if (this.mifields.length > 0) {
                let tags = JSON.parse(this.item.tags || "{}");
                for (var k = 0; k < this.mifields.length; k++) {
                    tags[this.mifields[k].key] = this.mifields[k].value;
                }
                rows[0].tags = JSON.stringify(tags);
            }

            let variables = {
                rows,
            };
            if (this.fileUpload) {
                variables.rows[0].data = JSON.stringify(this.fileUpload);
            } else {
                variables.rows[0].data = "";
            }
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                  mutation inventorylines_save($rows: [InventoryLine_input], $dateformat: String) {
                    inventorylines_save(rows: $rows, dateformat: $dateformat) {
                      id
                    }
                  }
                `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.xml = null
            await this.load()

            this.busy = false;
        },

        async load_data(data) {
            this.message = ""
            this.load_busy = true;

            let variables = {
                selected: [{
                    id: this.item.id,
                }],
                data: this.item.associatedno.join(","),
                apply: true
            }
            console.log(variables)

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation inventorylines_load($selected: [InventoryLine_input], $data: String, $apply: Boolean) {
                            inventorylines_load(selected: $selected, data: $data, apply: $apply ) {
                                id
                            }
                        }
                        `,
                    variables,
                });
                this.message = "Data loaded to inventoryline"

            } catch (error) {
                this.message = error.message
                console.log(error)

            }
            await this.load()
            this.load_busy = false;
        },


        // sumcosttotal() {
        //     // this.costtotal = 0
        //     this.costtotal = 0
        //     if (this.itineraries.items) {
        //         for (var j = 0; j < this.itineraries.items.length; j++) {
        //             if (isNaN(this.itineraries.items[j].fare)) { this.itineraries.items[j].fare = "0" }
        //             this.itineraries.items[j].fare = parseFloat(this.itineraries.items[j].fare).toFixed(2)
        //             this.itineraries.items[j].total = (parseFloat(this.itineraries.items[j].fare) + parseFloat(this.itineraries.items[j].tax)).toFixed(2);

        //             // this.costtotal += parseFloat(this.sllines.items[j].cost)
        //             this.costtotal += parseFloat(this.itineraries.items[j].total)
        //         }
        //     }
        //     this.markup_costtotal = this.costtotal.toFixed(2)
        // },
        moveItem(data, from, to) {
            // remove `from` item and store it
            var f = data.splice(from, 1)[0];
            // insert stored item into position `to`
            data.splice(to, 0, f);
        },
        reversenamecap(data, ispassenger) {
            if (data) {
                let result = data.toString().toUpperCase()
                if (result) {
                    let parts = result.split(' ')
                    result = parts[parts.length - 1] + "/"
                    if (ispassenger) { this.item.surname = parts[parts.length - 1] }
                    parts = parts.slice(0, -1)
                    if (parts.length > 0) {
                        result += parts.join(" ")
                        if (ispassenger) { this.item.firstname = parts.join(" ") }
                    }
                    this.item.title = ""
                }
                return result
            }
        },

        async download() {
            let variables = {
                name: "sheet_inventorylines",
            };
            console.log("variables", variables);

            this.busy = true;

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_systemsettings($name: String) {
              setup_systemsettings(name: $name) {
                data
              }
            }
          `,
                    variables,
                });

                if (response.data.setup_systemsettings.length > 0) {
                    let sheet = response.data.setup_systemsettings[0].data;

                    let byteCharacters = atob(sheet);
                    let byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    fs.saveAs(blob, 'TEMPLATE_inventorylines' + ".xlsx");
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async load_bankingline(id) {
            if (!id) {
                id = this.item.referenceno
            }
            console.log(id)
            let variables = {
                reference: id
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankingslines($reference: String) {
                            bankingslines(reference: $reference) {
                                data
                        }
                        }
                    `,
                    variables,
                });

                this.data = response.data.bankingslines[0].data

            } catch (error) {
                console.log(error);
            }
        }

    },
};
</script>

<style>
.ssh-pre__content {
    color: #3cb450;
}

.ssh-pre .quote {
    color: #0bc;
}

.ssh-pre[data-type="xml"] .tag-name {
    color: #c6d;
}
</style>